/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { GetApiStatisticsQueryResponse, GetApiStatisticsQueryParams, GetApiStatistics400, GetApiStatistics401, GetApiStatistics403, GetApiStatistics500 } from "../../types/GetApiStatistics.ts";
import { getApiStatisticsQueryResponseSchema } from "../../zod/AdminStatisticsSchemas/getApiStatisticsSchema.ts";

function getGetApiStatisticsUrl() {
  const res = { method: 'GET', url: `/api/statistics` as const }  
  return res
}

/**
 * @summary Получение статистики за период
 * {@link /api/statistics}
 */
export async function getApiStatistics({ params }: { params?: GetApiStatisticsQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetApiStatisticsQueryResponse, ResponseErrorConfig<GetApiStatistics400 | GetApiStatistics401 | GetApiStatistics403 | GetApiStatistics500>, unknown>({ method : "GET", url : getGetApiStatisticsUrl().url.toString(), params, ... requestConfig })  
  return getApiStatisticsQueryResponseSchema.parse(res.data)
}